export default "__VITE_ASSET__BU7h5T1R__"